import type { Organisation } from '@esf/shared';

/**
 * Co-branded demo organisations.
 *
 * ORG-001 — Ping Group (Belfast): operator / DPP issuer (the "tenant" that runs this platform)
 * ORG-002 — Thompson Aero Seating (Portadown, NI): manufacturer of the showcased seats
 * ORG-003 — Delta Air Lines (Atlanta, USA): launch customer / asset operator
 * ORG-004 — AVIC Cabin Systems (London): parent group, informational tenant
 */
export const demoOrganisations: Organisation[] = [
  {
    id: 'ORG-001',
    name: 'Ping Group',
    slug: 'ping-group',
    contactEmail: 'info@pinggroup.co.uk',
    contactPhone: '+44 28 9442 2888',
    address: 'Belfast International Airport, Aldergrove, Crumlin BT29 4AB',
    isEsfOrg: true,
    enabled: true,
    tier: 'enterprise',
    maxUsers: 50,
    createdAt: '2024-01-15T09:00:00.000Z',
    updatedAt: '2026-05-12T14:30:00.000Z',
  },
  {
    id: 'ORG-002',
    name: 'Thompson Aero Seating Ltd',
    slug: 'thompson-aero-seating',
    contactEmail: 'enquiries@thompsonaero.com',
    contactPhone: '+44 28 3839 8888',
    address: 'Sheepwalk Road, Portadown, Co. Armagh BT63 5RH',
    isEsfOrg: false,
    enabled: true,
    tier: 'enterprise',
    maxUsers: 40,
    createdAt: '2024-02-01T10:00:00.000Z',
    updatedAt: '2026-04-22T11:15:00.000Z',
  },
  {
    id: 'ORG-003',
    name: 'Delta Air Lines',
    slug: 'delta-air-lines',
    contactEmail: 'cabin-programmes@delta.com',
    contactPhone: '+1 404 715 2600',
    address: '1030 Delta Boulevard, Atlanta, GA 30354, USA',
    isEsfOrg: false,
    enabled: true,
    tier: 'enterprise',
    maxUsers: 25,
    createdAt: '2024-03-10T09:30:00.000Z',
    updatedAt: '2026-05-04T08:45:00.000Z',
  },
  {
    id: 'ORG-004',
    name: 'AVIC Cabin Systems',
    slug: 'avic-cabin-systems',
    contactEmail: 'compliance@aviccabinsystems.com',
    contactPhone: '+44 20 7946 0000',
    address: '5 Aldermanbury Square, London EC2V 7HR',
    isEsfOrg: false,
    enabled: true,
    tier: 'standard',
    maxUsers: 10,
    createdAt: '2024-04-15T10:00:00.000Z',
    updatedAt: '2026-03-18T15:20:00.000Z',
  },
];
